;(function () {
	if(wp.customize !== undefined) {
		wp.customize.bind('ready', function () {

			const changeField = 'store_colors__store_color_theme';
			const showHideField = 'store_colors__store_single_color_choice';
			const trueValue = 'theme--single-color-theme';
			wp.customize.control(changeField, function (control) {
				control.setting.bind(function (value) {
					switch (value) {
						case trueValue :
							wp.customize.control(showHideField).activate();
							break;

						default :
							wp.customize.control(showHideField).deactivate();
							break;
					}
				});
			});
		});
	}
})();